import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import EditAccountsViewPage from "components/pages/EditAccountsViewPage";
import ReorderAccountsPage from "components/pages/ReorderAccountsPage";
import Classes from "model";
import { useEffect } from "react";

export default function CaptureAccountsEditAccounts(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const { options } = branding;
    const optionsSetToReorderAccountsValue = Object.keys(options).reduce((acc, key) => {
        const val = options[key] ? options[key] : "";

        if(key.includes("acctsumwidget_link_") && val.toLowerCase().includes("reorder accounts")) {
            acc.push({ [key]: val });
        }
        return acc;
    }, []);
    const hasOptionsSetToReorderAccountsValue = optionsSetToReorderAccountsValue.length > 0;
    
    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    }); 

    // The video team requested that any options set to "Reorder Accounts"
    // should render the "Reorder Accounts" page for this capture.
    return hasOptionsSetToReorderAccountsValue ? <ReorderAccountsPage /> : <EditAccountsViewPage />
}